import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { billing_v1 as billingV1 } from '@careerstart/wae-common/src/main/constants/exports-csvs/billing';
import { convertDataToCSV } from '@careerstart/wae-common/src/main/constants/exports-csvs/export';
import {
  convertPayrollDataToCSV,
  payroll_v3 as payrollV3,
} from '@careerstart/wae-common/src/main/constants/payroll';

import ExportView from '../../../../components/ExportViewV2/ExportView';
import { EXPORT_TYPES } from '../../timekeepingConstants';

import { getSetData } from './helpers';

const TimekeepingExport = ({ filters, user, activeExport, onClose }) => {
  const [progress, setProgress] = useState(0);

  const isOpen = !!activeExport;

  const apiPathForExport =
    activeExport === EXPORT_TYPES.PAYROLL ? 'v3/payroll-data' : 'billing-data';

  const fileName = `${activeExport === EXPORT_TYPES.PAYROLL ? 'Payroll' : 'Billing'} Export`;

  const resultToCSVTextConverter = (grid) => {
    if (activeExport === EXPORT_TYPES.PAYROLL) {
      return convertPayrollDataToCSV(grid, payrollV3);
    }

    if (activeExport === EXPORT_TYPES.BILLING) {
      return convertDataToCSV(grid, billingV1);
    }
    return grid;
  };

  return (
    <ExportView
      isOpen={isOpen}
      onClose={onClose}
      getSetData={() =>
        getSetData({
          apiPath: apiPathForExport,
          filters,
          pageSize: 25,
          token: user?.token,
          setProgress,
        })
      }
      resultToCSVTextConverter={resultToCSVTextConverter}
      fileName={fileName}
      setProgress={(newProgress) => setProgress(newProgress)}
      progress={progress}
    />
  );
};

TimekeepingExport.propTypes = {
  onClose: PropTypes.func,
  user: PropTypes.shape({
    role: PropTypes.string,
    token: PropTypes.string,
  }),
  filters: PropTypes.arrayOf(PropTypes.shape({})),
  activeExport: PropTypes.string.isRequired,
};
export default TimekeepingExport;
